$(function(){
  $(document).on('click','.flashAlert',function(){
    $(this).remove();
  })
});